webpackJsonp([156446576476831],{

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactAnchorLinkSmoothScroll = __webpack_require__(24);
	
	var _reactAnchorLinkSmoothScroll2 = _interopRequireDefault(_reactAnchorLinkSmoothScroll);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _AboutUsComponent = __webpack_require__(63);
	
	var _AboutUsComponent2 = _interopRequireDefault(_AboutUsComponent);
	
	var _ContactComponent = __webpack_require__(39);
	
	var _ContactComponent2 = _interopRequireDefault(_ContactComponent);
	
	var _CtaComponent = __webpack_require__(40);
	
	var _CtaComponent2 = _interopRequireDefault(_CtaComponent);
	
	var _LeadComponent = __webpack_require__(35);
	
	var _LeadComponent2 = _interopRequireDefault(_LeadComponent);
	
	var _LeadComponentServices = __webpack_require__(41);
	
	var _LeadComponentServices2 = _interopRequireDefault(_LeadComponentServices);
	
	var _SeoComponent = __webpack_require__(42);
	
	var _SeoComponent2 = _interopRequireDefault(_SeoComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThePage = function (_React$Component) {
	  _inherits(ThePage, _React$Component);
	
	  function ThePage() {
	    _classCallCheck(this, ThePage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ThePage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SeoComponent2.default, {
	        title: 'Meteor Entwickler gesucht? Wir sind Ihr Ansprechpartner',
	        description: 'Wir sind eine Gruppe von Meteor-Entwicklern mit Agentur-Sitz bei K\xF6ln und seit mehreren Jahren auf Meteor.js spezialisiert. Kontaktieren Sie uns doch einfach und wir besprechen Ihr Projekt pers\xF6nlich.'
	      }),
	      _react2.default.createElement(_LeadComponent2.default, {
	        leadText: 'Meteor Entwickler',
	        subText: 'Wir sind eine Agentur von <b>Meteor-Entwicklern</b> mit Sitz in NRW und seit mehreren Jahren auf <b>Meteor.js</b> spezialisiert. Sehr gerne unterst\xFCtzen wir Sie bei der Umsetzung Ihres Meteor-Projektes.<br/><br/>Schreiben Sie uns also gerne eine Nachricht<br/>und wir besprechen Ihr Projekt pers\xF6nlich.<br/>Telefonisch oder bei einer leckeren Tasse <i class="fas fa-coffee"></i> Kaffee\u2026'
	      }),
	      _react2.default.createElement(_LeadComponentServices2.default, { imageStore: this.props.imageStore }),
	      _react2.default.createElement(_AboutUsComponent2.default, { imageStore: this.props.imageStore }),
	      _react2.default.createElement(_CtaComponent2.default, null),
	      _react2.default.createElement(_ContactComponent2.default, null)
	    );
	  };
	
	  return ThePage;
	}(_react2.default.Component);
	
	exports.default = ThePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-meteor-meteor-entwickler-js-2667b8f901ba3b16277a.js